module.exports = __webpack_public_path__ + "static/media/Rajdhani-SemiBold.f63c2b05.ttf";